<div class="m193-page">

  <!-- Cabecera -->
  <div class="m193-header">
    <div class="m193-header__icon"><mat-icon>assignment</mat-icon></div>
    <div>
      <h1 class="m193-header__title">Modelo 193</h1>
      <p class="m193-header__sub">Declaración de retenciones por capital mobiliario</p>
    </div>
  </div>

  <!-- Acciones -->
  <div class="m193-actions">
    <button mat-stroked-button class="m193-btn" (click)="getData()">
      <mat-icon>refresh</mat-icon> Calcular / Actualizar
    </button>
    <button mat-stroked-button class="m193-btn" (click)="getFile()">
      <mat-icon>file_download</mat-icon> Descargar fichero
    </button>
    <button mat-stroked-button class="m193-btn" (click)="validate()">
      <mat-icon>check</mat-icon> Validar datos
    </button>
    <button mat-stroked-button class="m193-btn" (click)="redirectFileTax()">
      <mat-icon>send</mat-icon> Presentar impuesto
    </button>
  </div>

  <!-- Loading -->
  <div class="m193-loading" *ngIf="isLoading">
    <mat-progress-spinner diameter="36" mode="indeterminate"></mat-progress-spinner>
    <p>Calculando…</p>
  </div>

  <ng-container *ngIf="!isLoading">

    <!-- Alertas de validación -->
    <div class="m193-alerts" *ngIf="validations && validations.length > 0">
      <div class="m193-alert" *ngFor="let item of validations; trackBy: trackByIndex">
        <span class="m193-alert__text">{{ item.message }}</span>
        <button class="m193-alert__link" *ngIf="item.key" (click)="scrollToElement(item.key)">Ir al campo</button>
      </div>
    </div>

    <div class="m193-card">
      <div class="m193-card__head">
        <mat-icon>assignment</mat-icon>
        <span class="m193-card__head-label">Declaración</span>
      </div>
      <div class="m193-card__body">
        <mat-tab-group animationDuration="0ms">
          <mat-tab label="Declarante y resumen de la declaración">
            <div class="container mt-1 mb-1">
              <div class="row">
                <div class="col-12 mt-1 mb-1" style="padding: 10px 0px 10px 0px;">
                  <span class="m193-subhead">Datos del declarante</span>
                </div>
                <div class="col-4 mt-1 mb-1">
                  <span>NIF</span>
                  <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
                </div>
                <div class="col-4 mt-1 mb-1">
                  <span>Apellido y nomre o razón social del declarante</span>
                  <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
                </div>
                <div class="col-4 mt-1 mb-1">
                  <span>Ejercicio</span>
                  <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
                </div>

                <div class="col-12 mt-1 mb-1" style="padding: 10px 0px 10px 0px;">
                  <span class="m193-subhead">Persona con quién relacionarse</span>
                </div>
                <div class="col-4 mt-1 mb-1">
                  <span>Teléfono</span>
                  <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
                </div>
                <div class="col-6 mt-1 mb-1">
                  <span>Apellidos y nombre</span>
                  <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
                </div>

                <div class="col-12 mt-1 mb-1" style="padding: 10px 0px 10px 0px;">
                  <span class="m193-subhead">Resumen de la declaración</span>
                </div>
                <div class="col-6 mt-1 mb-1" style="padding-top: 6px;">
                  <span>Número total de perceptores</span>
                </div>
                <div class="col-3 mt-1 mb-1">
                  <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
                </div>
                <div class="col-6 mt-1 mb-1" style="padding-top: 6px;">
                  <span>Número total de Gastos</span>
                </div>
                <div class="col-3 mt-1 mb-1">
                  <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
                </div>
                <div class="col-6 mt-1 mb-1" style="padding-top: 6px;">
                  <span>Total Importe Base Retenciones e Ing. a Cta</span>
                </div>
                <div class="col-3 mt-1 mb-1">
                  <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
                </div>
                <div class="col-6 mt-1 mb-1" style="padding-top: 6px;">
                  <span>Total Retenciones e ingresos a cuenta</span>
                </div>
                <div class="col-3 mt-1 mb-1">
                  <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
                </div>
                <div class="col-6 mt-1 mb-1" style="padding-top: 6px;">
                  <span>Total retenciones e ingresos a cuenta Ingresados</span>
                </div>
                <div class="col-3 mt-1 mb-1">
                  <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
                </div>
                <div class="col-6 mt-1 mb-1" style="padding-top: 6px;">
                  <span>Total Gastos</span>
                </div>
                <div class="col-3 mt-1 mb-1">
                  <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
                </div>
                <div class="col-6 mt-1 mb-1" style="padding-top: 6px;">
                  <span>Naturaleza del declarante</span>
                </div>
                <div class="col-3 mt-1 mb-1">
                  <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
                </div>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="Perceptores">
            <div class="container mt-1 mb-1">
              <div class="row">
                <div class="col-12 mt-1 mb-1">
                  <button mat-stroked-button class="mt-1 mb-1" (click)="openModal(modelPerceptor)"
                    style="margin-right: 10px;margin-left:10px">
                    Añadir
                  </button>
                  <table class="table table-striped table-sm">
                    <thead>
                      <tr>
                        <td>Orden</td>
                        <td>Estado</td>
                        <td>Presentado el</td>
                        <td>NIF del perceptor</td>
                        <td>NIF del representante legal</td>
                        <td>Apellidos y nombre, razón social o denominación del perceptor</td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>01</td>
                        <td>Estado</td>
                        <td>Presentado</td>
                        <td>NIF_perceptor</td>
                        <td>Nif_repre</td>
                        <td>Apellido</td>
                        <td>
                          <button mat-stroked-button class="mt-2" (click)="openModal(modelPerceptor)"
                            style="margin-right: 10px;margin-left:10px">
                            Editar
                          </button>
                          <button mat-stroked-button class="mt-2" (click)="openModal(modelPerceptor)"
                            style="margin-right: 10px;margin-left:10px">
                            Eliminar
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>

    <ng-template #modelPerceptor>
      <div class="container mt-1 mb-1">
        <div class="row">
          <div class="col-3 mt-1 mb-1">
            <span>Pendiente</span>
            <br />
            <mat-checkbox id="" name="" [(ngModel)]="data"></mat-checkbox>
          </div>
          <div class="col-3 mt-1 mb-1">
            <span>NIF Perceptor</span>
            <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
          </div>
          <div class="col-3 mt-1 mb-1">
            <span>NIF Representante</span>
            <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
          </div>
          <div class="col-3 mt-1 mb-1">
            <span>Apellidos y nombre, razón social o denominación del perceptor</span>
            <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
          </div>
          <div class="col-3 mt-1 mb-1">
            <span>C. Percepción</span>
            <select id="" name="" [(ngModel)]="data" class="w-100 form-control">
              <option value="Calle">Calle</option>
              <option value="2">No</option>
            </select>
          </div>
          <div class="col-3 mt-1 mb-1">
            <span>Naturaleza</span>
            <select id="" name="" [(ngModel)]="data" class="w-100 form-control">
              <option value="Calle">Calle</option>
              <option value="2">No</option>
            </select>
          </div>
          <div class="col-3 mt-1 mb-1">
            <span>Pago a un mediador</span>
            <br />
            <mat-checkbox id="" name="" [(ngModel)]="data"></mat-checkbox>
          </div>
          <div class="col-3 mt-1 mb-1">
            <span>Código provincia</span>
            <select id="" name="" [(ngModel)]="data" class="w-100 form-control">
              <option value="Calle">Calle</option>
              <option value="2">No</option>
            </select>
          </div>
          <div class="col-4 mt-1 mb-1">
            <span>Clave Código</span>
            <select id="" name="" [(ngModel)]="data" class="w-100 form-control">
              <option value="Calle">Calle</option>
              <option value="2">No</option>
            </select>
          </div>
          <div class="col-4 mt-1 mb-1">
            <span>Código emisor</span>
            <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
          </div>
          <div class="col-4 mt-1 mb-1">
            <span>Ejercicio de devengo</span>
            <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
          </div>
          <div class="col-3 mt-1 mb-1">
            <span>Pago</span>
            <select id="" name="" [(ngModel)]="data" class="w-100 form-control">
              <option value="Calle">Calle</option>
              <option value="2">No</option>
            </select>
          </div>
          <div class="col-3 mt-1 mb-1">
            <span>Tipo de código</span>
            <select id="" name="" [(ngModel)]="data" class="w-100 form-control">
              <option value="Calle">Calle</option>
              <option value="2">No</option>
            </select>
          </div>
          <div class="col-6 mt-1 mb-1">
            <span>CCV/Nº. Operación Préstamo</span>
            <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
          </div>
          <div class="col-4 mt-1 mb-1">
            <span>Tipo de Percepción</span>
            <select id="" name="" [(ngModel)]="data" class="w-100 form-control">
              <option value="Calle">Calle</option>
              <option value="2">No</option>
            </select>
          </div>
          <div class="col-4 mt-1 mb-1">
            <span>Importe Percepciones o Remuneración al Prestamista</span>
            <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
          </div>
          <div class="col-4 mt-1 mb-1">
            <span>Importe Reducciones</span>
            <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
          </div>
          <div class="col-4 mt-1 mb-1">
            <span>BBase Ret. Ing. a Cta.</span>
            <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
          </div>
          <div class="col-4 mt-1 mb-1">
            <span>% Retención</span>
            <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
          </div>
          <div class="col-4 mt-1 mb-1">
            <span>Ret. e Ing. a Cta.</span>
            <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
          </div>

          <div class="col-4 mt-1 mb-1">
            <span>Inicio del Préstamo</span>
            <input type="date" id="" name="" [(ngModel)]="data" class="w-100 form-control">
          </div>
          <div class="col-4 mt-1 mb-1">
            <span>Vto. del Préstamo</span>
            <input type="date" id="" name="" [(ngModel)]="data" class="w-100 form-control">
          </div>
          <div class="col-4 mt-1 mb-1"></div>
          <div class="col-4 mt-1 mb-1">
            <span>Penalizaciones</span>
            <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
          </div>
          <div class="col-4 mt-1 mb-1">
            <span>Compensaciones</span>
            <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
          </div>
          <div class="col-4 mt-1 mb-1">
            <span>Garantías</span>
            <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
          </div>
          <div class="col-12 mt-1 mb-1">
            Retenciones e ingresos a cuenta ingresados en el Estado, en las Diputaciones Forales del País Vasco
            y en la Comunidad Foral de Navarra:
          </div>
          <div class="col-4 mt-1 mb-1">
            <span>Hacienda Estatal</span>
            <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
          </div>
          <div class="col-4 mt-1 mb-1">
            <span>Comunidad Foral de Navarra</span>
            <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
          </div>
          <div class="col-4 mt-1 mb-1">
            <span>Diputación Foral de Araba/Álava</span>
            <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
          </div>
          <div class="col-4 mt-1 mb-1">
            <span>Diputación Foral de Gipuzkoa</span>
            <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
          </div>
          <div class="col-4 mt-1 mb-1">
            <span>Diputación Foral de Bizkaia</span>
            <input type="text" id="" name="" [(ngModel)]="data" class="w-100 form-control">
          </div>
          <div class="col-4 mt-1 mb-1">
            <span>Ceuta o Melilla / Isla de La Palma</span>
            <select id="" name="" [(ngModel)]="data" class="w-100 form-control">
              <option value="Calle">Calle</option>
              <option value="2">No</option>
            </select>
          </div>
        </div>

        <div class="col-12 mt-1 mb-1  text-end">
          <button mat-stroked-button class="mt-2" (click)="closeModal()" style="margin-right: 10px;margin-left:10px">
            Guardar
          </button>
          <button mat-stroked-button class="mt-2" (click)="closeModal()" style="margin-right: 10px;margin-left:10px">
            Cerrar
          </button>
        </div>
      </div>
    </ng-template>

    <app-tax-disclaimer-notice></app-tax-disclaimer-notice>

  </ng-container>

</div>
